<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Tariff Details</ion-title>
            </ion-buttons>
            <ion-buttons slot="end">
            <ion-button class="hdrBtn" @click="addNewTariff">
                <ion-icon v-slot: start :icon="add" ></ion-icon>&nbsp;Add Tariff
            </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <TariffCreation />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
import TariffCreation from "@/components/admin/TariffCreation.vue";
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'tariffCreation',
    components: {
      TariffCreation, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton, IonButton, IonIcon
    },
    data() {
        return {
            add
        }
    },
    methods: {
        navigatePreviousPage() {
        this.$router.go(-1)
        },
        
        addNewTariff() {
            this.$router.push("addNewTariff"); 
        }
    }
})
</script>